function formatErrorSummary(errorMessage, wordLimit = 20) {
    if (!errorMessage || typeof errorMessage !== 'string') {
      return 'Something went wrong.';
    }
  
    const match = errorMessage.match(/ERROR MESSAGE:\s*(.*)/s);
    const mainMessage = match ? match[1].trim() : errorMessage.trim();
  
    const firstWords = mainMessage.split(/\s+/).slice(0, wordLimit).join(" ");
  
    return `Something went wrong: ${firstWords}...`;
  }
  
  export default formatErrorSummary;